import React, {useEffect, useState} from "react";
import { useTranslation } from 'react-i18next';
import { Dropdown } from 'primereact/dropdown';

const LanguageSelector = ({appInsights}) => {

    const { t, i18n } = useTranslation();


    const languages = [
        { name: t('ES'), code: 'es' },
        { name: t('FR'), code: 'fr' },
        { name: t('PT'), code: 'pt' },
        { name: t('PT-BR'), code: 'pt-br' },
        { name: t('EN'), code: 'en' },
        { name: t('DE'), code: 'de' },
        { name: t('IT'), code: 'it' },
        { name: t('HE'), code: 'he' },
    ];

    // Initialize language state based on current i18n.language
    const [language, setLanguage] = useState(() => {
        const currentLangCode = i18n.language || 'es'; // default to 'es'
        return languages.find(lang => lang.code === currentLangCode) || languages[0];
    });

    const changeLanguage = ({ value }) => {
        const language = value.code
        i18n.changeLanguage(value.code);
        setLanguage(value); // update the state to trigger re-render
        if (appInsights) {
            appInsights.trackEvent({ name: "Language Change", properties: { language } });
        }    };

    const filteredLanguages = languages.filter(lang => lang.code !== language.code);

    return (
        <div className="language-selector pl-1 sm:pl-3 ">
            <Dropdown
                value={language.code}
                dropdownIcon={() => false}
                showOnFocus={true}
                onChange={ changeLanguage }
                options={filteredLanguages}
                optionLabel="name"
                placeholder={language.name}
                dropdownicon="none"
                clearIcon={null}
                panelClassName="language-selector-panel"
                className="w-fit p-0 bg-transparent color-primary text-xl py-1" />
        </div>
    )
}



export default LanguageSelector
